import { useTranslation } from "react-i18next";

import { APIFilter } from "shared/api/utils";
import { useConfigContext } from "shared/contexts/ConfigContext";

import Tooltip from "features/components/Tooltip";
import { DEFAULT_FILTER_BUILDER_STATE } from "features/ui/Filters/FilterBuilder/constants";
import {
  filterBuilderQueryToFilterBuilderState,
  getFiltersQuery,
} from "features/ui/Filters/FilterBuilder/utils";
import Link from "features/ui/Link";

import { useRepairLaborLink } from "./utils";

interface Props {
  assetFilter: string;
  repairLaborFilter: APIFilter[];
  repairLaborCount?: number;
}

const PriceAdvisorRepairLaborLink = ({
  assetFilter,
  repairLaborFilter,
  repairLaborCount = 0,
}: Props) => {
  const { t } = useTranslation("duck");
  const { pages } = useConfigContext();

  const assetFilterState = filterBuilderQueryToFilterBuilderState(assetFilter);

  const link = useRepairLaborLink(
    getFiltersQuery(undefined, repairLaborFilter),
    getFiltersQuery(assetFilterState ?? DEFAULT_FILTER_BUILDER_STATE)
  );

  if (!pages.repairLabor) {
    return (
      <span className="text-xs">
        {t("recent_labor_items", { count: repairLaborCount })}
      </span>
    );
  }

  return (
    <Link to={link} target="_blank">
      <Tooltip title={t("labor_items_tooltip")}>
        <span className="text-xs">
          {t("recent_labor_items", { count: repairLaborCount })}
        </span>
      </Tooltip>
    </Link>
  );
};

export default PriceAdvisorRepairLaborLink;
